import * as React from 'react';
import { Link } from 'react-router-dom';
import { Eyebrow } from './Eyebrow';
import { marketingFeatures, marketingPaths } from './marketingData';
import styles from './MarketingPage.module.css';

export const MarketingLink = ({
  href,
  children,
  secondary = false,
}: {
  href: string;
  children: React.ReactNode;
  secondary?: boolean;
}) => {
  const className = secondary ? styles.ButtonSecondary : styles.Button;
  return href.startsWith('http') || href.startsWith('#') ? (
    <a className={className} href={href}>
      {children}
    </a>
  ) : (
    <Link className={className} to={href}>
      {children}
    </Link>
  );
};

export const MarketingHero = ({
  eyebrow,
  title,
  summary,
  actions,
  proof,
  visual,
}: {
  eyebrow: React.ReactNode;
  title: React.ReactNode;
  summary: React.ReactNode;
  actions?: React.ReactNode;
  proof?: React.ReactNode;
  visual?: React.ReactNode;
}) => (
  <section className={styles.Hero}>
    <div className={styles.HeroCopy}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className={styles.Title}>{title}</h1>
      <p className={styles.Subheading}>{summary}</p>
      {actions && <div className={styles.Actions}>{actions}</div>}
      {proof && <div className={styles.Proof}>{proof}</div>}
    </div>
    {visual && <div className={styles.HeroVisual}>{visual}</div>}
  </section>
);

export const MarketingSection = ({
  id,
  title,
  intro,
  narrow = false,
  children,
}: {
  id?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  narrow?: boolean;
  children?: React.ReactNode;
}) => (
  <section className={styles.Section} id={id}>
    <div className={`${styles.SectionInner} ${narrow ? styles.Narrow : ''}`}>
      {title && <h2 className={styles.Heading}>{title}</h2>}
      {intro && <p className={styles.Intro}>{intro}</p>}
      {children}
    </div>
  </section>
);

export const Placeholder = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.Placeholder}>
    <strong>Content to confirm:</strong> {children}
  </div>
);

export const MarketingPage = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.Page}>{children}</div>
);

export const FeatureLinks = () => (
  <div className={styles.Grid4}>
    {marketingFeatures.map((feature) => (
      <Link key={feature.slug} className={styles.Card} to={marketingPaths.feature(feature.slug)}>
        <h3>{feature.label}</h3>
        <p>{feature.title}</p>
      </Link>
    ))}
  </div>
);

export { styles as marketingStyles };
